import { useEffect, useState } from 'react';
import { subscribeToasts } from './toastBus';

const TYPE_STYLES = {
  success: 'border-l-4 border-green-600 bg-white',
  error: 'border-l-4 border-red-600 bg-white',
  info: 'border-l-4 border-gray-400 bg-white',
};

const AUTO_DISMISS_MS = 5000;

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return subscribeToasts((toast) => {
      setToasts((prev) => [...prev, toast]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, AUTO_DISMISS_MS);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-80">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="alert"
          className={`shadow-lg rounded-md px-4 py-3 text-sm text-gray-900 ${TYPE_STYLES[toast.type] || TYPE_STYLES.info}`}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}
